import { HStack, Button, Flex } from "@chakra-ui/react";
import { useNavigate, useLocation } from "react-router-dom";

const tabs = [
  { label: "멤버 관리", path: "/member" },
  { label: "제안 및 선정", path: "/suggest" },
  { label: "컨텐츠 제작 모니터링", path: "/contents" },
  { label: "성과 측정", path: "/result" },
  { label: "정산 및 종료", path: "/settlement" },
  { label: "CPS 커미션", path: "/cps-commissions" },
  { label: "DM", path: "/dm" },
  { label: "감사 로그", path: "/audit" },
];

export default function HeaderTabs() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Flex
      h="64px"
      w="100%"
      alignItems="center"
      borderBottom="1px solid"
      borderColor="gray.100"
      bg="white"
      position="relative"
      px="20px"
      boxShadow="0 1px 2px rgba(0,0,0,0.04)"
    >
      {/* 중앙 탭 영역 - 서브탭과 동일 스타일 */}
      <HStack
        gap={0}
        bg="gray.100"
        border="1px solid"
        borderColor="gray.200"
        borderRadius="8px"
        p={0}
        position="absolute"
        left="50%"
        transform="translateX(-50%)"
        maxW={{ base: "calc(100% - 120px)", md: "none" }}
        overflowX="auto"
        overflowY="hidden"
        css={{ "&::-webkit-scrollbar": { height: "4px" } }}
      >
        {tabs.map((tab, index) => {
          const active = location.pathname.startsWith(tab.path);
          const isFirst = index === 0;
          const isLast = index === tabs.length - 1;
          return (
            <Button
              key={tab.path}
              onClick={() => navigate(tab.path)}
              variant="ghost"
              fontFamily="Pretendard, sans-serif"
              fontWeight="700"
              fontSize="14px"
              color={active ? "white" : "#747F8C"}
              bg={active ? "#0054C0" : "white"}
              borderRight={isLast ? "none" : "1px solid"}
              borderColor="gray.200"
              px="4"
              py="2.5"
              borderTopLeftRadius={isFirst ? "7px" : 0}
              borderBottomLeftRadius={isFirst ? "7px" : 0}
              borderTopRightRadius={isLast ? "7px" : 0}
              borderBottomRightRadius={isLast ? "7px" : 0}
              _hover={{
                bg: active ? "#0047A3" : "gray.200",
                color: active ? "white" : "#747F8C",
              }}
              _active={{
                bg: active ? "#0054C0" : "white",
                color: active ? "white" : "#747F8C",
              }}
              transition="all 0.2s ease"
              flexShrink={0}
              borderRightColor={active ? "transparent" : "gray.200"}
            >
              {tab.label}
            </Button>
          );
        })}
      </HStack>

      {/* 오른쪽 버튼 영역 */}
      <Flex ml="auto" gap="8px">
        <Button
          onClick={() => navigate(`/notices`)}
          variant="outline"
          size="sm"
          fontFamily="Pretendard, sans-serif"
          fontWeight="700"
          borderColor="gray.200"
          color="gray.600"
          _hover={{ bg: "gray.50", borderColor: "gray.300" }}
          borderRadius="8px"
        >
          공지사항
        </Button>
      </Flex>
    </Flex>
  );
}
